import { SelectOption } from '../../../../model/selectOption'
import { CheckboxSelectConditionItemLabel } from '../CheckboxSelectConditionItemLabel'

type ProjectMemberMultiAutocompleteConditionItemLabelProps = {
  header: string
  value: string[] | undefined
  isLoading?: boolean
  onChange: (value: string[] | undefined) => void
  search: () => void
  onClose?: () => void
  memberOptions: SelectOption[]
}

export const ProjectMemberMultiAutocompleteConditionItemLabel = ({
  header,
  value,
  isLoading,
  onChange,
  onClose,
  search,
  memberOptions,
}: ProjectMemberMultiAutocompleteConditionItemLabelProps) => {
  return (
    <CheckboxSelectConditionItemLabel
      header={header}
      value={value}
      onChange={onChange}
      onClose={onClose}
      search={search}
      options={memberOptions}
      isLoading={isLoading}
    />
  )
}
